// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ApplicationWithRelationsSchema } from './ApplicationRelationsSchema'
import type { ApplicationWithRelations } from './ApplicationRelationsSchema'
import { TechnologyStackSchema } from './TechnologyStackSchema'
import type { TechnologyStack } from './TechnologyStackSchema'
import { FileScopingDataSchema } from './FileScopingDataSchema'
import type { FileScopingData } from './FileScopingDataSchema'
import { ApplicationScopingSchema } from './ApplicationScopingSchema';

/////////////////////////////////////////
// APPLICATION SCOPING RELATION SCHEMA
/////////////////////////////////////////

export type ApplicationScopingRelations = {
  application: ApplicationWithRelations;
  techStack: TechnologyStack[];
  fileScopingData?: FileScopingData | null;
};

export type ApplicationScopingWithRelations = z.infer<typeof ApplicationScopingSchema> & ApplicationScopingRelations

export const ApplicationScopingWithRelationsSchema: z.ZodType<ApplicationScopingWithRelations> = ApplicationScopingSchema.merge(z.object({
  application: z.lazy(() => ApplicationWithRelationsSchema),
  techStack: z.lazy(() => TechnologyStackSchema).array(),
  fileScopingData: z.lazy(() => FileScopingDataSchema).nullable(),
}))